/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calibration_Temperature_Error_OfflineInputs */



/**
* | output |
* | --- |
* | "All head th. in the room must be connected" |
*
* @param {Calibration_Temperature_Error_OfflineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_error_offline = /** @type {((inputs?: Calibration_Temperature_Error_OfflineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_Error_OfflineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("All head th. in the room must be connected")
	return /** @type {LocalizedString} */ ("Toutes les têtes th. de la pièce doivent être connectées")
});